import React, { useReducer, useEffect, useMemo } from 'react';
import "./AnalogClock.scss";
import { useSettings } from "../../../utils/contentContext";

const AnalogClock = () => {
  const [, tick] = useReducer((n) => n + 1, 0);
  const { timezoneIana } = useSettings();

  useEffect(() => {
    const timer = setInterval(tick, 1000);
    return () => clearInterval(timer);
  }, []);

  const getLocalTime = () => {
    const formatter = new Intl.DateTimeFormat("en-GB", {
      timeZone: timezoneIana,
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: false,
    });

    const parts = formatter.formatToParts(new Date());
    const timeObj = {};
    parts.forEach(({ type, value }) => {
      if (type !== "literal") {
        timeObj[type] = parseInt(value, 10);
      }
    });
    return timeObj;
  };

  const { hour: hours, minute: minutes, second: seconds } = getLocalTime();

  // The 72 dial marks never change, but the component re-renders every second.
  // Building them once lets React skip the whole subtree on each tick.
  const marks = useMemo(
    () => (
      <>
        {Array.from({ length: 12 }).map((_, index) => (
          <div
            key={`hour_${index}`}
            className="mark hour-mark"
            style={{ transform: `rotate(${index * 30}deg)` }}
          >
            <div className="mark-line" />
          </div>
        ))}
        {Array.from({ length: 60 }).map((_, index) => (
          <div
            key={`minute_${index}`}
            className="mark minute-mark"
            style={{ transform: `rotate(${index * 6}deg)` }}
          >
            <div className="minute-mark-line" />
          </div>
        ))}
      </>
    ),
    []
  );

  const hourDegrees = ((hours % 12) + minutes / 60) * 30;
  const minuteDegrees = (minutes + seconds / 60) * 6;
  const secondDegrees = seconds * 6;
  
  return (
    <div className="clock-container">
      <div className="clock">
        {marks}
        <div className="hand hour-hand" style={{ transform: `rotate(${hourDegrees}deg)` }} />
        <div className="hand minute-hand" style={{ transform: `rotate(${minuteDegrees}deg)` }} />
        <div className="hand second-hand" style={{ transform: `rotate(${secondDegrees}deg)` }} />
      </div>
    </div>
  );
};

export default AnalogClock;
